import type {
  TaskProgressorRequestMode,
  TaskProgressorRequestTargetStage,
  TaskProgressorContractSummary,
  TaskProgressorRequest,
  TaskProgressorStageOption,
} from '@urbanx/agx.activities.client'
import type { CampaignAdminModel } from '@urbanx/agx.campaigns.client'
import type { DropdownOption } from '@urbanx/agx.ui-components2'
import { cleanTwoLineAddress } from 'helpers/address'

interface BuildTaskProgressorRequestOptions {
  agencyId: string
  campaignId: string
  contractId?: string
  selectedStage: string
  mode: TaskProgressorRequestMode
  campaignVersion: string
}

export const buildTaskProgressorRequest = ({
  agencyId,
  campaignId,
  contractId,
  selectedStage,
  mode,
  campaignVersion,
}: BuildTaskProgressorRequestOptions): TaskProgressorRequest => ({
  agencyId,
  campaignId,
  contractId,
  targetStage: selectedStage as TaskProgressorRequestTargetStage,
  mode,
  campaignVersion,
})

export const getStageOptions = (
  stageOptions: TaskProgressorStageOption[] | undefined,
  includeTaskOnlyStages: boolean
): DropdownOption[] =>
  (stageOptions ?? [])
    .filter(
      (stageOption) =>
        includeTaskOnlyStages || Boolean(stageOption.changeStageProjection)
    )
    .filter((stageOption): stageOption is Required<TaskProgressorStageOption> =>
      Boolean(stageOption.stage && stageOption.label)
    )
    .map((stageOption) => ({
      label: stageOption.label,
      value: stageOption.stage,
    }))

export const getSelectedStageLabel = (
  stage: string | undefined,
  options: TaskProgressorStageOption[] | undefined
): string => {
  if (!stage) return '-'

  return options?.find((option) => option.stage === stage)?.label ?? stage
}

export const getContractLabel = (
  contract: TaskProgressorContractSummary
): string =>
  contract.currentStageLabel
    ? `${contract.label} - ${contract.currentStageLabel}`
    : (contract.label ?? 'Contract')

export const formatCampaignAddress = (campaign: CampaignAdminModel): string =>
  cleanTwoLineAddress(campaign.address).filter(Boolean).join(', ')
